import { FC, lazy } from "react";

const ContactPersonAddress = lazy(
  () =>
    import(
      "@components/ContactPersonDetails/ContactPersonAddress/ContactPersonAddress"
    )
);
const ContactPersonBlock = lazy(
  () =>
    import(
      "@components/ContactPersonDetails/ContactPersonBlock/ContactPersonBlock"
    )
);
import { ContactPersonModalProps } from "@models/components/contactPerson.model";

const ContactPersonModal: FC<ContactPersonModalProps> = ({ contactDetail }) => {
  const contactPersonAddressProps = {
    address: contactDetail?.clubAddress,
    email: contactDetail?.email,
    phone: contactDetail?.phone,
  };

  const contactPersonBlockProps = {
    companyName: contactDetail?.name,
    designation: contactDetail?.designation,
    email: contactDetail?.email,
    personName: contactDetail?.name,
    phone: contactDetail?.phone,
  };

  return (
    <div className="container" data-testid="contact-person-page">
      <div className="row">
        <ContactPersonBlock data={contactPersonBlockProps} />
        <ContactPersonAddress {...contactPersonAddressProps} />
      </div>
    </div>
  );
};

export default ContactPersonModal;
